export class EventBus<DetailType = any> {

    private eventTarget: EventTarget;

    constructor(description = '') { this.eventTarget = document.appendChild(document.createComment(description)); }

    on(type: string, listener: (event: CustomEvent<DetailType>) => void) {
        this.eventTarget.removeEventListener(type, listener as EventListenerOrEventListenerObject);
        this.eventTarget.addEventListener(type, listener as EventListenerOrEventListenerObject);
    }

    once(type: string, listener: (event: CustomEvent<DetailType>) => void) {
        this.eventTarget.addEventListener(type, listener as EventListenerOrEventListenerObject, { once: true });
    }

    off(type: string, listener: (event: CustomEvent<DetailType>) => void) {
        this.eventTarget.removeEventListener(type, listener as EventListenerOrEventListenerObject);
    }

    emit(type: string, detail?: DetailType) {
        console.log(`%c⚡ event bus - emit ${type}`,  "color:#888;font-weight:bold;")
        return this.eventTarget.dispatchEvent(new CustomEvent(type, { detail }));
    }
}

export const appEventBus = new EventBus("app-event-bus");